import playlist from "../../apis/playlist";

export default {
  /////////////////////////////////////////////////////////////////////////////
  ////////////////////////////PLAYLIST//////////////////////////////////
  ////////////////////////////////////////////////////////////////////////////

  get_playlist({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await playlist.get_playlist(payload);
        commit("GET_PLAYLIST", data.data);
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },

  getall_playlist({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await playlist.getall_playlist(payload);
        commit("GET_ALL_PLAYLIST", data.data);
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },

  add_playlist({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await playlist.add_playlist(payload);
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },

  update_playlist({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await playlist.update_playlist(payload);
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },

  delete_playlist({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await playlist.delete_playlist(payload);
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },

  ///////////////////////////////////////////////////////////////////
  ////////////////////////////CATEGORY////////////////////////////
  /////////////////////////////////////////////////////////////////

  get_category({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await playlist.get_category(payload);
        commit("GET_CATEGORY", data.data);
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },

  getall_category({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await playlist.getall_category(payload);
        commit("GET_ALL_CATEGORY", data.data);
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },

  add_category({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await playlist.add_category(payload);
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },

  update_category({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await playlist.update_category(payload);
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },

  delete_category({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await playlist.delete_category(payload);
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },

  ///////////////////////////////////////////////////////////////////
  ////////////////////////////EPISODE/////////////////////////////
  /////////////////////////////////////////////////////////////////

  get_episode({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await playlist.get_episode(payload);
        commit("GET_EPISODE", data.data);
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },

  getall_episode({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await playlist.getall_episode(payload);
        commit("GET_ALL_EPISODE", data.data);
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },

  add_episode({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await playlist.add_episode(payload);
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },

  update_episode({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await playlist.update_episode(payload);
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },

  delete_episode({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await playlist.delete_episode(payload);
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },

  ///////////////////////////////////////////////////////////////////
  ////////////////////////////HISTORY/////////////////////////////
  /////////////////////////////////////////////////////////////////

  getall_history({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await playlist.getall_history(payload);
        commit("GET_ALL_HISTORY", data.data);
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },

  add_history({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await playlist.add_history(payload);
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },

  update_history({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await playlist.update_history(payload);
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },
  ///////////////////////////////////////////////////////////////
  ////////////////////////////FORM/////////////////////////////
  //////////////////////////////////////////////////////////////

  getall_form({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await playlist.getall_form(payload);
        commit("GET_ALL_FORM", data.data);
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },

  add_form({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await playlist.add_form(payload);
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },

  update_form({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await playlist.update_form(payload);
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },

  delete_form({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await playlist.delete_form(payload);
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },
};
